const THEME = laravel.config.THEME;
const config = {

    showLoginVideo: false,
	app: {
		name: 'Wripple',
		version: process.env.APP_VERSION,
	},

    use_clearbit: false,//process.env.USE_CLEARBIT === 'true',
	color: {
        primary: THEME['--theme-primary'],
        secondary: THEME['--theme-secondary'],
        success: THEME['--theme-success'],
        info: THEME['--theme-info'],
        warning: THEME['--theme-warning'],
        danger: THEME['--theme-danger'],

        'primary-light': THEME['--theme-primary-light'],
        'secondary-light': THEME['--theme-secondary-light'],
        'success-light': THEME['--theme-success-light'],
        'info-light': THEME['--theme-info-light'],
        'warning-light': THEME['--theme-warning-light'],
        'danger-light': THEME['--theme-danger-light'],

        'primary-lighter': THEME['--theme-primary-lighter'],
        'secondary-lighter': THEME['--theme-secondary-lighter'],
        'success-lighter': THEME['--theme-success-lighter'],
        'info-lighter': THEME['--theme-info-lighter'],
        'warning-lighter': THEME['--theme-warning-lighter'],
        'danger-lighter': THEME['--theme-danger-lighter'],

		'primary-lightest': THEME['--theme-primary-lightest'],
		'secondary-lightest': THEME['--theme-secondary-lightest'],
		'success-lightest': THEME['--theme-success-lightest'],
		'info-lightest': THEME['--theme-info-lightest'],
		'warning-lightest': THEME['--theme-warning-lightest'],
		'danger-lightest': THEME['--theme-danger-lightest'],

        'primary-dark': THEME['--theme-primary-dark'],
        'secondary-dark': THEME['--theme-secondary-dark'],
        'success-dark': THEME['--theme-success-dark'],
        'info-dark': THEME['--theme-info-dark'],
        'warning-dark': THEME['--theme-warning-dark'],
        'danger-dark': THEME['--theme-danger-dark'],

		'primary-darker': THEME['--theme-primary-darker'],
		'secondary-darker': THEME['--theme-secondary-darker'],
		'success-darker': THEME['--theme-success-darker'],
		'info-darker': THEME['--theme-info-darker'],
		'warning-darker': THEME['--theme-warning-darker'],
		'danger-darker': THEME['--theme-danger-darker'],

        'primary-darkest': THEME['--theme-primary-darkest'],
		'secondary-darkest': THEME['--theme-secondary-darkest'],
		'success-darkest': THEME['--theme-success-darkest'],
		'info-darkest': THEME['--theme-info-darkest'],
		'warning-darkest': THEME['--theme-warning-darkest'],
		'danger-darkest': THEME['--theme-danger-darkest'],

        light_purple: THEME['--theme-secondary'],
		purple: THEME['--theme-primary'],
		green: THEME['--theme-success'],
		blue: THEME['--theme-info'],
		navy: '#90A0B7',
		orange: THEME['--theme-warning'],
		red: THEME['--theme-danger'],
		black: '#000000',
        backgroundGray: '#F5F6F8',
        gray: '#D3D8DD',
        light_green: THEME['--theme-success-light'],// '#5AE399',
        disabled: '#90a0b7'
	},

	api: {
		// host: 'https://sandbox.app.wripple.com',
	},

	log: {
		hide: window.location.hostname == 'app.wripple.com'
			|| window.location.hostname == 'demo.app.wripple.com'
			|| false,
		events: false,
		http: {
			requests: false,
			responses: false,
			response_times: false,
		},
	},

	authStorageKeys: [
		'Has_Seen_Teams_Intro_Tip',
		'Has_Seen_Teams_Setup_Tip',
		// 'Has_Seen_Talent_Welcome',
        'prev_session',
		'user_preferences',
		'app_version',
		'pusherTransportTLS',
        'resume_imports',
        'browseTalentSideFilters',
        'browseTeamsSideFilters'
	]

	// api: {
	// 	errors: {
	// 		bad_credentials() {

	// 		},
	// 	}
	// },
};

export default config;